import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import {
  TopMatchCell,
  EventSampleCell,
  AttributesCell,
  EventDataCell,
} from '@vlabs/pages/events/cells';

// FIXME: пока добавила мемо, чтобы избежать ререндеров, вообще надо функцию выкинуть и сделать просто компонент с колонками
export const useEventTableColumns = (onTopMatchCardClick, onEventCardClick, isTopMatchHidden, includedAttributes) => {
  const { t } = useTranslation();

  return useMemo(() => {
    const columns = [
      {
        Header: t('events:table header.event image'),
        id: 'eventImage',
        accessor: (value) => value,
        Cell: ({ value }) => (
          <EventSampleCell
            onEventClick={() => {
              onEventCardClick(value);
            }}
            original={value}
          />
        ),
      },
      {
        Header: t('events:table header.event details'),
        id: 'eventInfo',
        accessor: (value) => value,
        Cell: ({ value }) => (
          <EventDataCell
            original={value}
          />
        ),
      },
      {
        Header: t('events:table header.attributes'),
        id: 'attributes',
        accessor: (value) => value,
        Cell: ({ value }) => (
          <AttributesCell
            includedAttributes={includedAttributes}
            original={value}
          />
        ),
      },
    ];

    if (!isTopMatchHidden) {
      columns.splice(1, 0, {
        Header: t('events:table header.top match'),
        id: 'topMatch',
        accessor: (value) => value,
        Cell: ({ value }) => (
          <TopMatchCell
            onTopMatchCardClick={() => {
              onTopMatchCardClick(value?.top_match);
            }}
            original={value}
            topMatch={value?.top_match}
          />
        ),
      });
    }

    return columns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTopMatchHidden, t]);
};
